export default {
  name: "Invoices",

  types: {
    debit: "Debit",
    credit: "Credit",
  },

  history: {
    title: "Invoice history",
    createdOn: "Created on",
  },

  export: {
    title: "Export sent invoices",
    input: {
      startDate: "Start date",
      endDate: "End date",
    },
    button: {
      download: "Download",
    },
  },

  api: {
    invoiceInvoice: {
      id: {
        notNull: "Something went wrong, unknown invoice",
      },
      dueDate: {
        notNull: "A due date is required",
      },
      invoiceDate: {
        notNull: "An invoice date is required",
      },
    },

    invoiceTarget: {
      id: {
        notNull: "Something went wrong, unknown invoice",
      },
      entityTypeId: {
        notNull: "Select if you want to invoice a company or contact",
      },
      targetId: {
        notNull: "Select your invoice target",
      },
      status: {
        invalid: "Invoice target can only be changed on Draft invoices",
      }
    },

    invoiceItems: {
      notNull: "Please add some invoice lines to the invoice",
      name: {
        notNull: "Give all items a name",
      },
    },

    // Todo - check and fix this error message
    pdf: {
      found: "Can not generate PDF since once with this invoice number already exists. Manually change the invoice number of contact support.",
    },
  },
}
